import { useEffect } from 'react';

import { translateTier } from 'src/_mock/user/points';
import { useUserStore } from 'src/stores/user/user.store';
import { useMyLevelStore } from 'src/stores/user/my-level.store';
import { useAnalyticsContext } from 'src/providers/analytics-provider';

export const useSendNotesBottomsheet = () => {
  const { openSendNotes, setOpenSendNotes } = useUserStore();
  const { myLevelInfo, getMyLevelInfo } = useMyLevelStore();
  const { logAction } = useAnalyticsContext();

  useEffect(() => {
    if (openSendNotes) {
      logAction('invoicesModal', '', '', ['roxcode', 'cn_firebase'], {
        log_name: 'viva_invoices_modal_open',
        user_tier: translateTier[myLevelInfo?.userActualTier!],
        since_date: myLevelInfo?.actualLevel?.sinceDate,
        open_date: new Date().toLocaleString('pt-BR', {
          timeZone: 'America/Sao_Paulo',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }),
      });
      getMyLevelInfo();
    }
  }, [openSendNotes]);

  const onClose = () => {
    logAction('invoicesClose', '', '', ['roxcode', 'cn_firebase'], {
      log_name: 'viva_invoices_modal_close',
      close_date: new Date().toLocaleString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }),
    });
    setOpenSendNotes(false, logAction);
  };

  const onClickButton = (type: 'iris' | 'prizor') => {
    logAction('invoicesClick', type, '', ['roxcode', 'cn_firebase'], {
      log_name: `viva_invoices_click_${type}`,
      user_tier: translateTier[myLevelInfo?.userActualTier!],
      since_date: myLevelInfo?.actualLevel?.sinceDate,
      click_date: new Date().toLocaleString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }),
    });
    if (type === 'prizor') {
      window.open(
        `superapp://viva/prizor/campanhas/${translateTier[myLevelInfo?.userActualTier!]}/${myLevelInfo?.actualLevel?.sinceDate}/home`,
        '_self'
      );
    } else {
      window.open('superapp://viva/iris', '_self');
    }
    onClose();
  };

  return {
    openSendNotes,
    onClose,
    onClickButton,
  };
};
